export default __webpack_public_path__ + "static/media/bt.6c3893ff.svg";